import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { Form, FormText } from 'react-bootstrap';
import { isEmpty } from 'lodash';
import TextInput from '../inputs/TextInput';
import WithTranslation from '../../../hocs/WithTranslation';

class BasicTextArea extends Component {
    static propTypes = {
        className: PropTypes.string,
        description: PropTypes.string,
        defaultValue: PropTypes.string,
        disabled: PropTypes.bool,
        displayHelp: PropTypes.bool,
        input: PropTypes.shape({
            value: PropTypes.string,
            name: PropTypes.string,
            onChange: PropTypes.func
        }).isRequired,
        inputClassName: PropTypes.string,
        label: PropTypes.string,
        maxLength: PropTypes.string,
        meta: PropTypes.object.isRequired,
        placeholder: PropTypes.string,
        required: PropTypes.bool,
        rows: PropTypes.number,
        styleProps: PropTypes.object,
        type: PropTypes.string,
        labelClassName: PropTypes.string
    };

    getGroupClassName = () => {
        const { required, className } = this.props;
        return cns(className, {
            required
        });
    };

    getFeedbackMessage = () => {
        const { touched, error, warning } = this.props.meta;
        let message = '';
        if (touched) {
            if (error) {
                message = error;
            } else if (warning) {
                message = warning;
            }
        }
        return message;
    };

    getValidationState = () => {
        const { touched, error, warning } = this.props.meta;
        if (touched && error) {
            return 'error';
        }
        if (touched && warning) {
            return 'warning';
        }
        return null;
    };

    render() {
        const {
            defaultValue,
            label,
            description,
            input: { name, value, onChange },
            meta,
            placeholder,
            required = false,
            type = 'text',
            rows = 3,
            displayHelp = true,
            disabled,
            maxLength,
            inputClassName = '',
            styleProps = {},
            labelClassName = ''
        } = this.props;
        const { horizontal = false, inputStyle = {} } = styleProps;
        let labelSection = null;
        if (label || description) {
            labelSection = (
                <div className={horizontal ? `col-12 col-sm-6 company-form-field ${labelClassName} no-padding` : ''}>
                    <div className={horizontal ? 'col-12 col-sm-10 no-padding' : ''}>
                        <label htmlFor={name} className={horizontal ? 'form-label' : ''}>
                            {label}
                            {required && <span className={'required-tag'}>*</span>}
                        </label>
                        <p className={horizontal ? 'form-description' : ''}> {description} </p>
                    </div>
                </div>
            );
        }
        const helpBlock = displayHelp ? <FormText>{this.getFeedbackMessage()}</FormText> : null;
        return (
            <Form.Group className={this.getGroupClassName()} validated={this.getValidationState()}>
                {labelSection}
                <div className={cns('basic-text-area', inputClassName)}>
                    <TextInput
                        disabled={disabled}
                        componentClass={'textarea'}
                        onChange={onChange}
                        value={isEmpty(value) && meta.touched === false ? defaultValue : value}
                        required={required}
                        rows={rows}
                        maxLength={maxLength}
                        placeholder={placeholder}
                        type={type}
                        styleProps={inputStyle}
                    />
                    {helpBlock}
                </div>
            </Form.Group>
        );
    }
}

export default WithTranslation(BasicTextArea);
